var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-wrapper"},[_c('base-category',{attrs:{"categoryData":_vm.dummyData}}),_c('grid-template',{attrs:{"cols":"4"}},_vm._l((_vm.value.product_card),function(card){return _c('product-card',{key:card.product_title,attrs:{"card":card}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }